<big-ui-modal-frame
    *transloco="let t; prefix: 'uiModalSickNoteDetails'"
    [closeBtnTitle]="t('closeOverlayBtn')"
    [contentClass]="'print:pt-0'"
    (closeModal)="popoverRef.close()">
    <ng-container title>
        @for (diagnosis of sickNote.diagnosis; track $index; let isLast = $last) {
            {{ diagnosis.text }}{{ !isLast ? ', ' : '' }}
        }
    </ng-container>
    <ng-container subtitle>
        <p class="mb-0 font-bold">
            {{ t('benefitStart', { date: sickNote.benefit.start | date }) }} | {{ t('benefitEnd', { date: sickNote.sickNote.end | date }) }}
            <span class="hidden print:inline">({{ t(sickNote.type === 'GescannteAU' ? 'tag.scanned' : 'tag.default') }})</span>
        </p>
        <div class="print:hidden">
            <big-ui-tag [title]="t(sickNote.type === 'GescannteAU' ? 'tag.scannedLong' : 'tag.defaultLong')">
                {{ t(sickNote.type === 'GescannteAU' ? 'tag.scanned' : 'tag.default') }}
            </big-ui-tag>
        </div>
    </ng-container>
    <ng-container content>
        <div class="grid flex-1 grid-cols-1 gap-8 print:p-0">
            <!-- Diagnosen -->
            <div>
                <p class="mb-2">
                    <strong>{{ t('diagnoses.title') }}</strong>
                </p>
                <p class="mb-2">
                    {{ t('diagnoses.code') }}
                    @for (diagnosis of sickNote.diagnosis; track $index; let isLast = $last) {
                        {{ diagnosis.code }}{{ !isLast ? ', ' : '' }}
                    }
                </p>
                <ul class="col-span-1 mb-0 grid gap-2">
                    <ng-container *ngTemplateOutlet="listItem; context: { title: sickNote.typeOfCertificate }" />

                    @if (sickNote.workOrOtherAccitent) {
                        <ng-container *ngTemplateOutlet="listItem; context: { title: t('diagnoses.workOrOtherAccitent') }" />
                    }

                    @if (sickNote.transitDoctorAssigned) {
                        <ng-container
                            *ngTemplateOutlet="
                                listItem;
                                context: {
                                    title: t('diagnoses.transitDoctorAssigned'),
                                    id: 'transit-doctor-assigned',
                                    infoText: t('diagnoses.transitDoctorAssignedInfoText'),
                                }
                            " />
                    }
                </ul>
            </div>

            <!-- Diagnose Zusatz -->
            @if (sickNote.otherAccident || sickNote.suffering) {
                <div>
                    <p class="mb-2">
                        <strong>{{ t('diagnosisAddition.title') }}</strong>
                    </p>
                    <ul class="col-span-1 mb-0 grid gap-2">
                        @if (sickNote.otherAccident) {
                            <ng-container *ngTemplateOutlet="listItem; context: { title: t('diagnosisAddition.otherAccident') }" />
                        }
                        @if (sickNote.suffering) {
                            <ng-container
                                *ngTemplateOutlet="
                                    listItem;
                                    context: {
                                        title: t('diagnosisAddition.suffering'),
                                        id: 'suffering',
                                        infoText: t('diagnosisAddition.sufferingInfoText'),
                                    }
                                " />
                        }
                    </ul>
                </div>
            }

            <!-- Einleitung folgender Maßnahmen -->
            @if (sickNote.medicalRehabilitation || sickNote.gradualReintegration) {
                <div>
                    <p class="mb-2">
                        <strong>{{ t('furtherMeasures.title') }}</strong>
                    </p>
                    <ul class="col-span-1 mb-0 grid gap-2">
                        @if (sickNote.medicalRehabilitation) {
                            <ng-container
                                *ngTemplateOutlet="
                                    listItem;
                                    context: {
                                        title: t('furtherMeasures.medicalRehabilitation'),
                                        id: 'medical-rehabilitation',
                                        infoText: t('furtherMeasures.medicalRehabilitationInfoText'),
                                    }
                                " />
                        }
                        @if (sickNote.gradualReintegration) {
                            <ng-container
                                *ngTemplateOutlet="
                                    listItem;
                                    context: {
                                        title: t('furtherMeasures.gradualReintegration'),
                                        id: 'gradual-reintegration',
                                        infoText: t('furtherMeasures.gradualReintegrationInfoText'),
                                    }
                                " />
                        }
                    </ul>
                </div>
            }

            <!-- Im Krankengeldfall -->
            @if (sickNote.sicknessMoney || sickNote.finalCertificate) {
                <div>
                    <p class="mb-2">
                        <strong>{{ t('sicknessBenefit.title') }}</strong>
                    </p>
                    <ul class="col-span-1 mb-0 grid gap-2">
                        @if (sickNote.sicknessMoney) {
                            <ng-container *ngTemplateOutlet="listItem; context: { title: t('sicknessBenefit.sicknessMoney') }" />
                        }
                        @if (sickNote.finalCertificate) {
                            <ng-container
                                *ngTemplateOutlet="
                                    listItem;
                                    context: {
                                        title: t('sicknessBenefit.finalCertificate'),
                                        id: 'final-certificate',
                                        infoText: t('sicknessBenefit.finalCertificateInfoText'),
                                    }
                                " />
                        }
                    </ul>
                </div>
            }

            <!-- Ausstellender Arzt -->
            <div>
                <p class="mb-2">
                    <strong>{{ t('issuingDoctor.title') }}</strong>
                </p>
                <p class="mb-0">
                    {{ t('issuingDoctor.name', { title: sickNote.doctor.title, firstName: sickNote.doctor.firstName, lastName: sickNote.doctor.lastName }) }}
                    <br />
                    {{ t('issuingDoctor.number', { number: sickNote.doctor.number }) }}
                    <br />
                    {{ t('issuingDoctor.workplaceNumber', { workspaceNumber: sickNote.doctor.workplaceNumber }) }}
                </p>
            </div>

            <div class="print:hidden">
                <big-ui-button
                    [buttonStyle]="'primary'"
                    (clicked)="printSickNote($event)">
                    <big-icon
                        [icon]="iconDownload"
                        [size]="'w-5'"
                        [attr.aria-label]="t('downloadBtn')" />
                    <span>{{ t('downloadBtn') }}</span>
                </big-ui-button>
            </div>
        </div>
    </ng-container>
</big-ui-modal-frame>

<ng-template
    #listItem
    let-title="title"
    let-id="id"
    let-infoText="infoText">
    <li class="group">
        <div class="flex items-center gap-4">
            <div class="bg-primary-500 flex h-5 w-5 items-center justify-center rounded-full dark:bg-white print:hidden">
                <big-icon
                    [icon]="iconOk"
                    [size]="'w-3'"
                    [inline]="true"
                    class="dark:fill-primary-500 fill-white" />
            </div>
            <span class="leading-none">{{ title }}</span>
            @if (id && infoText) {
                <big-ui-info-button
                    [scrollAnchorId]="id"
                    (infoLayerOpened)="onInfoLayerOpen($event, id)"
                    class="ml-4 print:hidden"></big-ui-info-button>
            }
        </div>

        @if (openInfoTextIds().includes(id) && infoText) {
            <div
                [id]="id"
                class="bg-primary-50 border-primary-200 dark:bg-primary-600 dark:border-primary-400 mt-2 mb-2 rounded-xl border-2 p-3 group-last:mb-0 print:hidden">
                {{ infoText }}
            </div>
        }
    </li>
</ng-template>
